import React from 'react';
import { Notification, Box } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { token as previewToken } from '../../utils/preview';

// Waiting on final design. TODO: https://mixgenius.atlassian.net/browse/MG-36247
const PreviewNotification = () => {
    const exitPreview = () => {
        window.location.href = '/';
    };

    return previewToken ? (
        <Box
            position="fixed"
            top="4"
            left="50%"
            transform="translateX(-50%)"
            zIndex="subOverlay"
            css={{
                '& button': {
                    whiteSpace: 'nowrap',
                },
                '& span': {
                    whiteSpace: 'normal',
                },
                '& .notification': {
                    maxWidth: 'calc(100vw - 2rem)',
                    width: 'max-content',
                    height: 'auto',
                },
            }}
        >
            <Notification
                variant="danger"
                kind="temporary"
                onClose={exitPreview}
                className="notification"
            >
                <b>
                    <Trans>Preview Mode</Trans>
                </b>
                : <Trans>Close this dialog to exit preview mode.</Trans>
            </Notification>
        </Box>
    ) : null;
};

export default PreviewNotification;
